/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/HintsOption',{
    Enable: true,
    Disable: false
});
